/*
 * vg-color-swatches.js — Victoria's Gala
 * Converts the "Color" variant fieldset into circular swatches
 * (viragodress.com style) without breaking the native variant picker.
 * Also injects a SELECTED COLOR NAME above the swatches (Lulus style).
 *
 * Priority for resolving the color hex:
 *   1. Hex/rgb from Shopify's rendered <span class="swatch"> (metaobject)
 *   2. Hex from local COLOR_MAP
 *   3. CSS-named color fallback (e.g. 'salmon', 'teal')
 */
(function () {
  'use strict';

  var COLOR_MAP = {
    'rojo': '#d71920', 'rojo coral': '#ff6f61', 'coral': '#ff7f50', 'salmon': '#fa8072',
    'vino tinto': '#7a1023', 'vino': '#7a1023', 'borgona': '#702238', 'cereza': '#c4002a',
    'carmin': '#960018', 'fucsia': '#d7197d', 'magenta': '#ff00ff',
    'rosa': '#f4a7b9', 'rosado': '#f4a7b9', 'rosa palo': '#e8c7c2', 'palo rosa': '#e8c7c2',
    'rosa bebe': '#fadadd', 'rosa pastel': '#f8c8d5', 'rosa chicle': '#ff77a8', 'rosa viejo': '#c08081',
    'nude': '#d6b7a1', 'palo de rosa': '#c8898b',
    'azul': '#0b2f6b', 'azul royal': '#1f5fbf', 'azul noche': '#0b1f3a', 'azul marino': '#0b1f3a',
    'azul electrico': '#0057ff', 'azul rey': '#1d39c4', 'azul cielo': '#87ceeb', 'azul cobalto': '#2c70c9',
    'azul petroleo': '#1f4e5f', 'azul acero': '#7f95a5', 'azulino': '#1f4fa3', 'celeste': '#9fd3f3',
    'turquesa': '#40e0d0', 'aqua': '#7fffd4', 'aguamarina': '#7fdbda', 'agua marina': '#7dcbc3',
    'agua': '#7fdbff', 'verde agua': '#3fcfc3', 'teal': '#008080', 'acero': '#5bbeac', 'denim': '#1560bd',
    'verde': '#1f7a4d', 'verde esmeralda': '#007f5f', 'verde botella': '#064236', 'verde menta': '#a8d5c8',
    'verde olivo': '#6b7a3e', 'verde militar': '#4b5320', 'verde oliva': '#808000', 'verde manzana': '#8dc63f',
    'verde lima': '#bfff00', 'verde jade': '#00a86b', 'jade': '#00a86b', 'oliva': '#6b7a3e', 'menta': '#98ff98',
    'amarillo': '#ffd400', 'amarillo mostaza': '#d4a017', 'mostaza': '#d4a017', 'ocre': '#cc7722',
    'naranja': '#ff7a00', 'naranja quemado': '#cc5500', 'durazno': '#fcb997', 'melocoton': '#fcb997',
    'morado': '#6a3fa0', 'lila': '#b89adf', 'violeta': '#8a2be2', 'purpura': '#a54dcf',
    'malva': '#9c6e8d', 'lavanda': '#b497d6', 'berenjena': '#5d3954', 'uva': '#6f2da8',
    'blanco': '#ffffff', 'blanco hueso': '#f5f0e1', 'ivory': '#f8f4ec', 'crema': '#f3ead7',
    'marfil': '#fffff0', 'beige': '#d8c3a5', 'arena': '#c2b280', 'camel': '#c19a6b',
    'taupe': '#8b7d6b', 'cafe': '#6b4423', 'marron': '#7a4a28', 'chocolate': '#3f2110',
    'tabaco': '#754c24', 'mocha': '#8b6f47', 'gris': '#9ca3af', 'gris claro': '#d1d5db',
    'gris oscuro': '#4b5563', 'gris perla': '#e5e4e2', 'gris plomo': '#5a5a5a', 'humo': '#73767a',
    'negro': '#111111',
    'dorado': '#c8a96a', 'oro': '#c8a96a', 'oro rosa': '#b76e79', 'plateado': '#c8c8c8',
    'plata': '#c8c8c8', 'bronce': '#cd7f32', 'cobre': '#b87333'
  };

  function normalize(s) {
    if (!s) return '';
    return s.toLowerCase().trim().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function legendText(legend) {
    if (!legend) return '';
    var clone = legend.cloneNode(true);
    var kids = clone.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++) kids[i].remove();
    return (clone.textContent || '').trim();
  }

  function isColorFieldset(fs) {
    var legendName = normalize(legendText(fs.querySelector('legend')));
    if (legendName === 'color' || legendName === 'colour' || legendName === 'colores') return true;
    var input = fs.querySelector('input[type="radio"]');
    if (input && input.name) {
      var prefix = normalize(input.name.split('-')[0]);
      if (prefix === 'color' || prefix === 'colour' || prefix === 'colores') return true;
    }
    return false;
  }

  function readMetaobjectSwatchColor(label) {
    var swatchEl = label.querySelector('.swatch');
    if (!swatchEl) return null;
    var inline = swatchEl.getAttribute('style') || '';
    var m = inline.match(/--swatch-background\s*:\s*([^;]+)/i);
    if (m && m[1]) {
      var v = m[1].trim();
      if (v && v.indexOf('url(') === -1) return v;
    }
    try {
      var cs = getComputedStyle(swatchEl);
      var bg = cs.getPropertyValue('--swatch-background');
      if (bg) { bg = bg.trim(); if (bg && bg.indexOf('url(') === -1) return bg; }
      var bgColor = cs.backgroundColor;
      if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') return bgColor;
    } catch (e) {}
    return null;
  }

  function tryCssNamed(name) {
    if (!name) return null;
    var probe = document.createElement('span');
    probe.style.color = name;
    document.body.appendChild(probe);
    var resolved = getComputedStyle(probe).color;
    document.body.removeChild(probe);
    if (!resolved || resolved === 'rgb(0, 0, 0)') return null;
    return resolved;
  }

  function resolveColor(name) {
    var key = normalize(name);
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    var tokens = key.split(/\s+/);
    if (tokens.length > 1) {
      for (var i = 0; i < tokens.length; i++) {
        if (COLOR_MAP[tokens[i]]) return COLOR_MAP[tokens[i]];
      }
    }
    return tryCssNamed(key);
  }

  /* ============================================================
     ✨ NEW: Inject selected color NAME above the swatches
     ============================================================ */
  function injectColorName(fs) {
    var existing = fs.querySelector('[data-vg-color-name]');
    var checked = fs.querySelector('input[type="radio"]:checked');
    var label = checked ? (checked.value || '') : '';

    if (existing) {
      if (existing.textContent !== label) existing.textContent = label;
      return;
    }

    var legend = fs.querySelector('legend');
    if (!legend) return;

    var nameEl = document.createElement('div');
    nameEl.className = 'vg-color-name';
    nameEl.setAttribute('data-vg-color-name', '');
    nameEl.textContent = label;

    // Insert AFTER legend, BEFORE the swatches
    if (legend.nextSibling) {
      legend.parentNode.insertBefore(nameEl, legend.nextSibling);
    } else {
      legend.parentNode.appendChild(nameEl);
    }
  }

  function enhanceFieldset(fs) {
    if (fs.dataset.vgSwatchProcessed === '1') {
      if (fs.classList.contains('vg-color-swatch-fieldset')) {
        resolveColors(fs);
        injectColorName(fs);
      }
      return;
    }
    if (!isColorFieldset(fs)) {
      fs.dataset.vgSwatchProcessed = '1';
      return;
    }
    fs.classList.add('vg-color-swatch-fieldset');
    resolveColors(fs);
    injectColorName(fs);
    fs.dataset.vgSwatchProcessed = '1';
  }

  function resolveColors(fs) {
    var labels = fs.querySelectorAll('label.variant-option__button-label');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var input = label.querySelector('input[type="radio"]');
      if (!input) continue;
      var value = input.value || '';
      label.setAttribute('data-color', value);
      label.setAttribute('title', value);
      label.setAttribute('aria-label', value);
      var color = readMetaobjectSwatchColor(label);
      if (!color) color = resolveColor(value);
      if (color) label.style.setProperty('--vg-swatch-color', color);
    }
  }

  function directText(el) {
    var s = '';
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3) s += n.textContent;
    }
    return s;
  }

  function enhanceSingleValue(div) {
    if (div.dataset.vgSwatchProcessed === '1') return;
    div.dataset.vgSwatchProcessed = '1';
    var nameText = normalize(directText(div));
    if (nameText !== 'color' && nameText !== 'colour' && nameText !== 'colores') return;
    var valueSpan = div.querySelector('.variant-option__swatch-value');
    if (!valueSpan) return;
    var value = (valueSpan.textContent || '').trim();
    if (!value) return;
    var color = resolveColor(value);
    if (!color) return;
    if (div.querySelector('.vg-color-swatch-single__circle')) return;
    var circle = document.createElement('span');
    circle.className = 'vg-color-swatch-single__circle';
    circle.setAttribute('aria-hidden', 'true');
    circle.setAttribute('title', value);
    circle.style.setProperty('--vg-swatch-color', color);
    div.classList.add('vg-color-swatch-single');
    div.insertBefore(circle, valueSpan);
  }

  function enhanceAll() {
    var pickers = document.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) {
      var fieldsets = pickers[i].querySelectorAll('fieldset.variant-option');
      for (var j = 0; j < fieldsets.length; j++) enhanceFieldset(fieldsets[j]);
      var singles = pickers[i].querySelectorAll('div.variant-option[data-testid="variant-option-single"]');
      for (var k = 0; k < singles.length; k++) enhanceSingleValue(singles[k]);
    }
  }

  /* ============================================================
     ✨ NEW: Listen to color change events globally
     ============================================================ */
  function handleColorChange(e) {
    var target = e.target;
    if (!target || target.type !== 'radio') return;
    var fs = target.closest('fieldset.vg-color-swatch-fieldset');
    if (!fs) return;
    injectColorName(fs);
  }
  document.addEventListener('change', handleColorChange, true);
  document.addEventListener('input', handleColorChange, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }
  document.addEventListener('shopify:section:load', enhanceAll);
  document.addEventListener('variant:change', enhanceAll);

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    raf(function () { enhanceAll(); pending = false; });
  }
  function startObserver() {
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);
})();
